export function accordions() {
    const accordionButtons = document.getElementsByClassName("accordion-button");
    const panels = document.getElementsByClassName("panel");
    const settingsContainer = document.getElementsByClassName("settings-container");
    const panelContent = document.getElementsByClassName("panel-content");

    for (let i = 0; i < accordionButtons.length; i++) {
        accordionButtons[i].addEventListener("click", function() {

            // only one accordion open
            if (accordionButtons[i].classList.contains('only-one-open')) {
                for (let j = 0; j < accordionButtons.length; j++) {
                    if (accordionButtons[j] !== this) {
                        accordionButtons[j].classList.remove('active');
                        accordionButtons[j].nextElementSibling.classList.remove('active');
                        accordionButtons[j].nextElementSibling.classList.remove('initial-open');
                        accordionButtons[j].nextElementSibling.style.maxHeight = null;
                    }
                }
            }

            // toggle active class on button
            this.classList.toggle("active");

            // panel
            let panel = this.nextElementSibling;

            // toggle active class on panel
            panel.classList.toggle("active");

            // open or close panel, always open in editmode
            if (!panel.classList.contains('always-open')) {

                // initial open
                if (panel.classList.contains('initial-open')) {
                    panel.style.maxHeight = null;
                    panel.classList.remove('initial-open');

                // regular
                } else {
                    if (panel.style.maxHeight) {
                        panel.style.maxHeight = null;
                    } else {
                        panel.style.maxHeight = panel.scrollHeight + "px";
                    }
                }
            }
        });
    }

    // scroll to accordion with matching anchor and open
    const anchor = window.location.hash.substr(1);

    if (anchor) {
        for (let i = 0; i < accordionButtons.length; i++) {
            const accordionAnchor = accordionButtons[i].previousElementSibling;

            if (accordionAnchor) {
                const accordionAnchorText = accordionAnchor.dataset.anchor;

                if (accordionAnchorText === anchor) {
                    //setTimeout(() => {

                        // scroll to accordion
                        accordionAnchor.scrollIntoView({
                            behavior: 'smooth',
                            block: 'start'
                        });

                        // open accordion
                        accordionButtons[i].classList.add('active');

                        let panel = accordionButtons[i].nextElementSibling;

                        panel.classList.add('active');

                        // initial open
                        if (panel.classList.contains('initial-open')) {
                            panel.style.maxHeight = null;
                            panel.classList.remove('initial-open');

                        // regular
                        } else {
                            if (panel.style.maxHeight) {
                                panel.style.maxHeight = null;
                            } else {
                                panel.style.maxHeight = panel.scrollHeight + "px";
                            }
                        }

                    //}, 1000);
                }

            }

        }
    }

    // initial open
    for (let i = 0; i < panels.length; i++) {
        if (panels[i].classList.contains('initial-open')) {
            panels[i].style.maxHeight = panels[i].scrollHeight + "px";
        }
    }

    // resize panel on content change
    for (let i = 0; i < settingsContainer.length; i++) {
        new ResizeObserver(() => {
            const panel = settingsContainer[i].parentNode;

            // only for active panels
            if (panel.classList.contains('active')) {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        }).observe(settingsContainer[i]);
    }

    // resize panel on content change
    for (let i = 0; i < panelContent.length; i++) {
        new ResizeObserver(() => {
            const panel = panelContent[i].parentNode;

            // only for active panels
            if (panel.classList.contains('active')) {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        }).observe(panelContent[i]);
    }
}
